import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import dayjs, { isDayjs } from 'dayjs';
import {
  Controller,
  FieldPath,
  FieldValues,
  UseFormReturn,
  useWatch,
} from 'react-hook-form';

type DateInputProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = {
  form: UseFormReturn<TFieldValues>;
  name: TName;
} & Omit<DatePickerProps, 'name' | 'value' | 'onChange' | 'onBlur'>;

export const DateInput = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  form,
  name,
  ...rest
}: DateInputProps<TFieldValues, TName>) => {
  const { control, setError } = form;
  const value = useWatch({ control, name });

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <DatePicker
          {...rest}
          {...field}
          value={value ? dayjs(value, 'YYYY-MM-DD') : null}
          format="DD/MM/YYYY"
          onChange={(newValue) => {
            if (isDayjs(newValue) && newValue.isValid()) {
              field.onChange(newValue.format('YYYY-MM-DD'));
            } else {
              field.onChange(undefined);
              setError(name, { message: 'Date invalide' });
            }
          }}
        />
      )}
    />
  );
};
